import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "TriageNotifications" */ "./lazyIndex"), { name: "TriageNotifications" });

export const lazySubscribeToRowNotifications: LazyAction<typeof lazyIndex.subscribeToRowNotifications, typeof lazyModule> = new LazyAction(lazyModule, m => m.subscribeToRowNotifications);
export const lazyUnsubscribeToRowNotifications: LazyAction<typeof lazyIndex.unsubscribeToRowNotifications, typeof lazyModule> = new LazyAction(lazyModule, m => m.unsubscribeToRowNotifications);

export { default as addCopilotCategoryToRow } from "./actions/addCopilotCategoryToRow";
export { default as addInboxRuleNotification } from "./actions/addInboxRuleNotification";
